import { AxiosError, AxiosResponse } from "axios";
import { injectable } from "inversify";

import "@/extensions/date.extensions";
import { ApiService } from "@/services/apiService";
import {IMembershipService} from "@/injection/interfaces";
import {SucceededOrNotResponse} from "@/types/responses";
import {Plan} from "@/types/entities/plan";

@injectable()
export class MembershipService extends ApiService implements IMembershipService {
    public async getMemberships(): Promise<Plan[] | SucceededOrNotResponse> {
        const response = await this
            ._httpClient.get<Plan[], AxiosResponse<Plan[]>>(`${process.env.VUE_APP_API_BASE_URL}/api/plans`)
            .catch(function (error: AxiosError): AxiosResponse<SucceededOrNotResponse> {
                return error.response as AxiosResponse<SucceededOrNotResponse>;
                });
        return response.data as Plan[];
    }

    public async updateMemberships(memberships: Plan[]): Promise<Plan[] | SucceededOrNotResponse> {
        const response = await this
            ._httpClient.put<Plan[], AxiosResponse<Plan[]>>(`${process.env.VUE_APP_API_BASE_URL}/api/plans`, 
            {
                memberships : memberships
            })
            .catch(function (error: AxiosError): AxiosResponse<SucceededOrNotResponse> {
                return error.response as AxiosResponse<SucceededOrNotResponse>;
                });
        return response.data as Plan[];
    }
}